import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    cities: [],
    states: [],
    countries: [],
    zips: [],
    accessory_states: [],
    accessory_cities: [],
    part_states: [],
    part_cities: [],
}

const RegroundReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_CITIES:
            return { ...state, cities: action.payload }
        case ClientActionTypes.GET_STATES:
            return { ...state, states: action.payload }
        case ClientActionTypes.GET_COUNTRIES:
            return { ...state, countries: action.payload }
        case ClientActionTypes.GET_ZIPS:
            return { ...state, zips: action.payload }
        case ClientActionTypes.GET_ACCESSORY_STATE:
            return { ...state, accessory_states: action.payload }
        case ClientActionTypes.GET_ACCESSORY_CITY:
            return { ...state, accessory_cities: action.payload }
        case ClientActionTypes.GET_PART_STATE:
            return { ...state, part_states: action.payload }
        case ClientActionTypes.GET_PART_CITY:
            return { ...state, part_cities: action.payload }
        case ClientActionTypes.CLEAR_CITIES:
            return {
                ...state,
                cities: [],
            }
        case ClientActionTypes.CLEAR_STATES:
            return {
                ...state,
                states: [],
            }
        default:
            return { ...state }
    }
}

export default RegroundReducer
